import React from 'react';
import {
  Quotation,
  QuotationUnit,
  CoverageCatalog,
  CoverageCatalogResume,
} from 'data-layer-cr/dist/models';
import { Grid, Box, Typography, makeStyles, Theme } from '@material-ui/core';
import InformationCardLayout from './InformationCardLayout';
import PriceInformation from './PriceInformation';
import DeductibleInformation from './DeductibleInformation';

const DOLLAR_CURRENCY = '$';

type Props = {
  title: string;
  quotation: Quotation;
  unit: QuotationUnit;
  coverageCatalogs: CoverageCatalog[];
  coverageCatalogResumes: CoverageCatalogResume[];
  paymentAmount: number;
};

const useStyles = makeStyles((theme: Theme) => ({
  radioContainer: {
    marginTop: theme.spacing(1) / 2,
  },
  radio: {
    padding: 0,
    marginTop: 2,
  },
  coverageContent: {
    marginTop: theme.spacing(1),
  },
  subtitleText: {
    fontSize: 17,
    fontWeight: 900,
  },
}));

const PriceInformacionCard = ({
  title,
  quotation,
  unit,
  coverageCatalogs,
  coverageCatalogResumes,
  paymentAmount,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <InformationCardLayout
      data-testid="price-informacion-card"
      iconSrc="svg/price_dollar.svg"
      iconAlt="price_dollar_icon"
      title={title}
    >
      <Grid item>
        <Box my={2}>
          <PriceInformation
            data-testid="prices-resume"
            total={unit.total.grandTotal}
            numberOfPayments={paymentAmount}
            currency={quotation.quotationProfile.typeOfMoney || DOLLAR_CURRENCY}
          />
        </Box>
      </Grid>
      <Grid item>
        <Typography variant="caption" className={classes.subtitleText}>
          Deducibles
        </Typography>
      </Grid>
      <DeductibleInformation
        data-testid="deductible-list"
        unit={unit}
        coverageCatalog={coverageCatalogs}
        coverageCatalogResumes={coverageCatalogResumes}
        currency={quotation.quotationProfile.typeOfMoney || DOLLAR_CURRENCY}
      />
    </InformationCardLayout>
  );
};

export default PriceInformacionCard;
